import { DocumentReference } from "@firebase/firestore-types";
import { Component } from "react";
import * as React from "react";
import { Button, Glyphicon, Nav, Navbar, NavItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import AdvancedStatementsTable from "src/components/projects/project/statements/advanced/AdvancedStatementsTable";
import "src/css/pages/projects/projectspage.css";
import { TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import {
  IAdvancedDualRateTableProps,
  IAdvancedDualRateTableState,
  IStatementRow,
} from "./interfaces";

export default class AdvancedDualRateTablePage extends Component<
  IAdvancedDualRateTableProps,
  IAdvancedDualRateTableState
> {
  private projectDocument: DocumentReference;
  public constructor(props: IAdvancedDualRateTableProps) {
    super(props);

    this.state = { loading: true, statements: [], activeIndex: -1, needsSaving: false };

    this.renderStatementsNavbar = this.renderStatementsNavbar.bind(this);

    this.statementDateChanged = this.statementDateChanged.bind(this);
    this.serviceStartDateChanged = this.serviceStartDateChanged.bind(this);
    this.serviceEndDateChanged = this.serviceEndDateChanged.bind(this);
    this.gridReadingChanged = this.gridReadingChanged.bind(this);
    this.onPeakGridReadingChanged = this.onPeakGridReadingChanged.bind(this);
    this.solarReadingChanged = this.solarReadingChanged.bind(this);
    this.onPeakSolarReadingChanged = this.onPeakSolarReadingChanged.bind(this);
    this.solarGeneratedChanged = this.solarGeneratedChanged.bind(this);
    this.onPeakCreditsChanged = this.onPeakCreditsChanged.bind(this);
    this.offPeakCreditsChanged = this.offPeakCreditsChanged.bind(this);
    this.yearsWithSolarChanged = this.yearsWithSolarChanged.bind(this);

    this.editStatement = this.editStatement.bind(this);
    this.saveStatement = this.saveStatement.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.updateTable = this.updateTable.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.saveAndNext = this.saveAndNext.bind(this);
    this.saveAndPrior = this.saveAndPrior.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
  }

  public componentDidMount() {
    setTimeout(() => {
      this.loadStatements();
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    return (
      <div className="statements-grid container-fixed-navbar">
        {this.renderStatementsNavbar()}
        <AdvancedStatementsTable
          appService={this.props.appService}
          isSimpleStatement={false}
          statements={this.state.statements}
          activeIndex={this.state.activeIndex}
          needsSaving={this.state.needsSaving}
          statementDateChanged={this.statementDateChanged}
          yearsWithSolarChanged={this.yearsWithSolarChanged}
          serviceStartDateChanged={this.serviceStartDateChanged}
          serviceEndDateChanged={this.serviceEndDateChanged}
          gridReadingChanged={this.gridReadingChanged}
          onPeakGridReadingChanged={this.onPeakGridReadingChanged}
          solarReadingChanged={this.solarReadingChanged}
          onPeakSolarReadingChanged={this.onPeakSolarReadingChanged}
          solarGeneratedChanged={this.solarGeneratedChanged}
          onPeakCreditsChanged={this.onPeakCreditsChanged}
          offPeakCreditsChanged={this.offPeakCreditsChanged}
          saveStatement={this.saveStatement}
          editStatement={this.editStatement}
          cancelChanges={this.cancelChanges}
          saveAndNext={this.saveAndNext}
          saveAndPrior={this.saveAndPrior}
        />
      </div>
    );
  }

  private renderStatementsNavbar() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    const projectPage = `/project/${projectId}`;
    return (
      <div className="subnavbar-navbar-container">
        <Navbar inverse={false} collapseOnSelect={true}>
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink to={projectPage}>
                <Glyphicon glyph="glyphicon glyphicon-circle-arrow-left" className="button-right" />
                Standard View
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight={true}>
              <NavItem>
                <Button
                  bsSize="small"
                  bsStyle="danger"
                  disabled={!this.state.needsSaving}
                  onClick={this.saveChanges}
                >
                  <Glyphicon glyph="glyphicon glyphicon-floppy-save" /> Save
                </Button>
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }

  private loadStatements() {
    const statements: IStatementRow[] = [];
    this.projectDocument
      .collection("statements")
      .orderBy("statementDate")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const {
              statementDate,
              serviceStartDate,
              serviceEndDate,
              yearsWithSolar,
            } = doc.data() as any;
            this.projectDocument
              .collection("simpleDualRateStatements")
              .doc(doc.id)
              .get()
              .then(simpleDoc => {
                let generated: number = 0;
                if (simpleDoc.exists) {
                  const { solarGenerated } = simpleDoc.data() as any;
                  generated = solarGenerated ? solarGenerated : 0;
                }
                this.projectDocument
                  .collection("advancedDualRateStatements")
                  .doc(doc.id)
                  .get()
                  .then(statement => {
                    if (statement.exists) {
                      const {
                        gridReading,
                        onPeakGridReading,
                        solarReading,
                        onPeakSolarReading,
                        onPeakCredits,
                        offPeakCredits,
                      } = statement.data() as any;
                      statements.push({
                        id: doc.id,
                        statementDate: statementDate ? statementDate : Date.now(),
                        serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
                        serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
                        yearsWithSolar: yearsWithSolar ? yearsWithSolar : 0,
                        gridReading: gridReading ? gridReading : 0,
                        onPeakGridReading: onPeakGridReading ? onPeakGridReading : 0,
                        solarReading: solarReading ? solarReading : 0,
                        onPeakSolarReading: onPeakSolarReading ? onPeakSolarReading : 0,
                        solarGenerated: generated,
                        onPeakCredits: onPeakCredits ? onPeakCredits : 0,
                        offPeakCredits: offPeakCredits ? offPeakCredits : 0,
                        isEditing: false,
                      });
                    }
                  });
              });
          }
        });
      })
      .then(() => {
        setTimeout(() => {
          this.setState({ loading: false, statements });
        }, TIMEOUT);
      });
  }

  private cancelChanges(e: any) {
    e.preventDefault();
    const id = this.state.statements[this.state.activeIndex].id;
    const activeIndex = this.state.activeIndex;
    this.projectDocument
      .collection("statements")
      .doc(id)
      .get()
      .then(doc => {
        if (doc.exists) {
          const {
            statementDate,
            serviceStartDate,
            serviceEndDate,
            yearsWithSolar,
          } = doc.data() as any;
          let generated: number = 0;

          this.projectDocument
            .collection("simpleDualRateStatements")
            .doc(doc.id)
            .get()
            .then(simpleDoc => {
              if (simpleDoc.exists) {
                const { solarGenerated } = simpleDoc.data() as any;
                generated = solarGenerated ? solarGenerated : 0;
              }
            })
            .then(() => {
              this.projectDocument
                .collection("advancedDualRateStatements")
                .doc(doc.id)
                .get()
                .then(statement => {
                  if (statement.exists) {
                    const {
                      gridReading,
                      onPeakGridReading,
                      solarReading,
                      onPeakSolarReading,
                      onPeakCredits,
                      offPeakCredits,
                    } = statement.data() as any;

                    this.state.statements[activeIndex] = {
                      id: doc.id,
                      statementDate: statementDate ? statementDate : Date.now(),
                      serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
                      serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
                      yearsWithSolar: yearsWithSolar ? yearsWithSolar : 0,
                      gridReading: gridReading ? gridReading : 0,
                      onPeakGridReading: onPeakGridReading ? onPeakGridReading : 0,
                      solarReading: solarReading ? solarReading : 0,
                      onPeakSolarReading: onPeakSolarReading ? onPeakSolarReading : 0,
                      solarGenerated: generated,
                      onPeakCredits: onPeakCredits ? onPeakCredits : 0,
                      offPeakCredits: offPeakCredits ? offPeakCredits : 0,
                      isEditing: false,
                    };
                  }
                });
            });
        }
      })
      .then(() => {
        setTimeout(() => {
          this.setState({
            statements: this.state.statements,
            activeIndex: -1,
            needsSaving: false,
          });
        }, TIMEOUT);
      });
  }

  private saveAndNext(e: any) {
    e.preventDefault();

    const activeIndex = this.state.activeIndex;
    this.saveStatement(this.state.statements[activeIndex], activeIndex, this.state.statements);
    this.editStatement(
      this.state.statements[activeIndex + 1],
      activeIndex + 1,
      this.state.statements
    );
  }
  private saveAndPrior(e: any) {
    e.preventDefault();

    const activeIndex = this.state.activeIndex;
    this.saveStatement(this.state.statements[activeIndex], activeIndex, this.state.statements);
    this.editStatement(
      this.state.statements[activeIndex - 1],
      activeIndex - 1,
      this.state.statements
    );
  }

  private saveChanges(e: any) {
    e.preventDefault();

    this.setState({ loading: true });
    const { statements } = this.state;

    statements.forEach(statement => {
      this.projectDocument
        .collection("statements")
        .doc(statement.id)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.projectDocument
              .collection("statements")
              .doc(doc.id)
              .update({
                statementDate: statement.statementDate,
                serviceStartDate: statement.serviceStartDate,
                serviceEndDate: statement.serviceEndDate,
                yearsWithSolar: statement.yearsWithSolar,
              })
              .then(() => {
                this.projectDocument
                  .collection("simpleDualRateStatements")
                  .doc(doc.id)
                  .update({
                    solarGenerated: statement.solarGenerated,
                  });
              })
              .then(() => {
                this.projectDocument
                  .collection("advancedDualRateStatements")
                  .doc(doc.id)
                  .get()
                  .then(advDoc => {
                    if (advDoc.exists) {
                      this.projectDocument
                        .collection("advancedDualRateStatements")
                        .doc(doc.id)
                        .update({
                          gridReading: statement.gridReading,
                          onPeakGridReading: statement.onPeakGridReading,
                          solarReading: statement.solarReading,
                          onPeakSolarReading: statement.onPeakSolarReading,
                          onPeakCredits: statement.onPeakCredits,
                          offPeakCredits: statement.offPeakCredits,
                        });
                    }
                  });
              })
              .then(() => {
                setTimeout(() => {
                  this.setState({ needsSaving: false });
                }, TIMEOUT);
              });
          }
        })
        .then(() => {
          setTimeout(() => {
            this.setState({ loading: false, needsSaving: false });
          }, TIMEOUT);
        });
    });
  }

  private editStatement(statement: IStatementRow, index: number, statements: IStatementRow[]) {
    statement.isEditing = true;
    this.setState({
      statements,
      activeIndex: index,
      needsSaving: true,
    });
  }
  private saveStatement(statement: IStatementRow, index: number, statements: IStatementRow[]) {
    statement.isEditing = false;
    this.setState({ statements, activeIndex: -1 });
  }

  private statementDateChanged(e: any) {
    this.state.statements[this.state.activeIndex].statementDate = new Date(
      e.currentTarget.value
    ).valueOf();
    this.updateTable();
  }
  private serviceStartDateChanged(e: any) {
    this.state.statements[this.state.activeIndex].serviceStartDate = new Date(
      e.currentTarget.value
    ).valueOf();
    this.updateTable();
  }
  private serviceEndDateChanged(e: any) {
    this.state.statements[this.state.activeIndex].serviceEndDate = new Date(
      e.currentTarget.value
    ).valueOf();
    this.updateTable();
  }
  private yearsWithSolarChanged(e: any) {
    this.state.statements[this.state.activeIndex].yearsWithSolar = Number(e.currentTarget.value);
    this.updateTable();
  }
  private gridReadingChanged(e: any) {
    this.state.statements[this.state.activeIndex].gridReading = Number(e.currentTarget.value);
    this.updateTable();
  }
  private onPeakGridReadingChanged(e: any) {
    this.state.statements[this.state.activeIndex].onPeakGridReading = Number(e.currentTarget.value);
    this.updateTable();
  }
  private solarReadingChanged(e: any) {
    this.state.statements[this.state.activeIndex].solarReading = Number(e.currentTarget.value);
    this.updateTable();
  }
  private onPeakSolarReadingChanged(e: any) {
    this.state.statements[this.state.activeIndex].onPeakSolarReading = Number(
      e.currentTarget.value
    );
    this.updateTable();
  }
  private solarGeneratedChanged(e: any) {
    this.state.statements[this.state.activeIndex].solarGenerated = Number(e.currentTarget.value);
    this.updateTable();
  }
  private onPeakCreditsChanged(e: any) {
    this.state.statements[this.state.activeIndex].onPeakCredits = Number(e.currentTarget.value);
    this.updateTable();
  }
  private offPeakCreditsChanged(e: any) {
    this.state.statements[this.state.activeIndex].offPeakCredits = Number(e.currentTarget.value);
    this.updateTable();
  }
  private updateTable() {
    this.setState({
      statements: this.state.statements,
      needsSaving: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/statements/advanced/dualrate/AdvancedDualRateTablePage.tsx